/* app/js/src/components/common/slide-to-confirm/slide-to-confirm.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
}
.slide-to-confirm-track {
  position: relative;
  width: 100%;
  height: 48px;
  padding: 0 4px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: transparent;
  overflow: hidden;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  box-sizing: border-box;
}
.slide-to-confirm-label {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.38);
  pointer-events: none;
  z-index: 0;
}
.slide-to-confirm-fill {
  position: absolute;
  left: 4px;
  top: 4px;
  bottom: 4px;
  width: 0;
  background: rgb(45, 187, 252);
  border-radius: 2px;
  transition: width 0.05s ease-out;
  pointer-events: none;
  z-index: 1;
}
.slide-to-confirm-handle {
  position: absolute;
  top: 4px;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  cursor: grab;
  transition: left 0.05s ease-out;
  z-index: 2;
}
.slide-to-confirm-handle:active {
  cursor: grabbing;
}
.slide-to-confirm-handle.confirmed {
  cursor: default;
}
/*# sourceMappingURL=slide-to-confirm.component.css.map */
